export interface GalleryImage {
  src: string
  fallback: string
  alt: string
}

/**
 * Large-format photography for the home page gallery.
 * Ordered for the editorial layout in components/Gallery.tsx.
 */
export const galleryImages: GalleryImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg',
    fallback:
      'https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg',
    alt: 'Steam rising from the wood-fired sauna at night',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2R6iFsj5APGTGwRYAVkiFK/470801593_122128867442570946_8740882224121444447_n.jpg',
    fallback:
      'https://cdn.magicpatterns.com/uploads/8jw5SDRb5f5nVzkkgx9KD2/470562478_122128866854570946_8321049361434838301_n.jpg',
    alt: 'Cold plunge in the ice baths after the sauna',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg',
    fallback:
      'https://cdn.magicpatterns.com/uploads/tCCtuiYevJjrLRPGX4h7mj/470823327_122128867136570946_1434913759190205541_n.jpg',
    alt: 'Gathering around the fire pit after dark',
  },
  {
    src: 'https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6NDI3MDQ0NzQ%3D/original/f8c79b29-e4b3-444c-a36f-e29b7eb7c294.jpeg?im_w=1440',
    fallback:
      'https://cdn.magicpatterns.com/uploads/6iFuFQHxKtTVkDK3NtymqK/543114991_122198079788570946_2516265263527440324_n.jpg',
    alt: 'The swimming pool beside the accommodation',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rRoWy9gzp3AD5YQF8xjNXU/3.jpg',
    fallback: 'https://cdn.magicpatterns.com/uploads/sWvm9mv4418jXg48MsR6We/6.jpg',
    alt: 'A group resting on mats inside the dome',
  },
  {
    src: 'https://a0.muscache.com/im/pictures/hosting/Hosting-42704474/original/fe32518c-f3bb-4193-8ba1-f8c45b2af0e0.jpeg?im_w=1440',
    fallback:
      'https://cdn.magicpatterns.com/uploads/9u6tyMyibEF3BymtNxTkix/2025-10-28_(1).webp',
    alt: 'Inside the boutique accommodation',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6Ew4gLtza9LmKtNg4QjtwM/472670554_122134502420570946_2241759590050120448_n.jpg',
    fallback:
      'https://cdn.magicpatterns.com/uploads/ffnbPcW2MxKqF2667fz2MN/542760348_122198079770570946_2686341410234026026_n_(1).jpg',
    alt: 'Open fields and low sun beside the retreat',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/m4hVoN9mtjeNnASznCQJRM/542755915_122198079710570946_106348140338141339_n_(1).jpg',
    fallback:
      'https://cdn.magicpatterns.com/uploads/hffDynZX3nXn2CNTPNVY6M/471428511_122131322642570946_6342459253165615123_n.jpg',
    alt: 'Warm evening light across the retreat grounds',
  },
]

export const galleryCategories = [
  'Accommodation',
  'Sauna',
  'Hot Tub',
  'Ice Baths',
  'Dome',
  'Pool',
  'Fire Pit',
  'Nature',
]
